import { view } from "@risingstack/react-easy-state";
import type { Product } from "../../common/types/productTypes";
import AlertMessage from "../../components/AlertMessage";
import contentStore from "../../stores/cms/contentStore";

type ProductProps = {
   product: Product;
};

const ProductWarnings = ({ product }: ProductProps) => {
   const warnings = contentStore.getCurrentWarnings();

   const filteredProductWarnings = warnings
      .filter((c) => c.warningtype?.includes("Produktdetaljsiden for valgte produkter"))
      .filter((c) => c.skus?.includes(product.sku));

   if (filteredProductWarnings.length === 0) {
      return null;
   }
   return (
      <aside className="tw-mb-3 print:tw-hidden">
         {filteredProductWarnings.map((warning) => (
            <AlertMessage key={warning.internalName} warning={warning} />
         ))}
      </aside>
   );
};

export default view(ProductWarnings);
